import { useEffect, useMemo, useState } from "react";
import {
	Badge,
	Col,
	Drawer,
	Pagination,
	Row,
	Space,
	Tag,
	Typography,
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import Title from "../layout/Title";
import useTranslation from "../../intl/useTranslation";
import SearchMissions from "./SearchMissions";
import MissionCard from "./MissionCard";
import MissionAdmin from "./MissionAdmin";
import returnStatValue from "../../lib/returnStatValue";
import TabNav from "../navigation/TabNav";

const { Text } = Typography;

const MissionsAdmin = () => {
	const [missions, setMissions] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalResults, setTotalResults] = useState(0);
	const [pageSize, setPageSize] = useState(50);
	const location = useLocation();
	const navigate = useNavigate();
	const { t } = useTranslation();

	const routes = [
		{
			label: t("missions.confirmations"),
			key: "",
			to: "",
		},
		{
			label: t("missions.proposals"),
			key: "proposals",
			to: "proposals",
		},
		{
			label: t("missions.drafts"),
			key: "drafts",
			to: "drafts",
		},
	];

	const type = useMemo(() => {
		if (location.pathname.includes("proposals")) return "proposal";
		if (location.pathname.includes("drafts")) return "draft";
		return null;
	}, [location.pathname]);

	const navigationType = useMemo(() => {
		if (location.pathname.includes("proposals")) return "proposals/";
		if (location.pathname.includes("drafts")) return "drafts/";
		return "";
	}, [location.pathname]);

	useEffect(() => {
		setCurrentPage(1);
	}, [type]);

	const matchMission = () => {
		if (typeof location.pathname.split("/")[2] === "undefined") return false;
		const missionId = location.pathname.split("/").slice(-1)[0];
		return (
			Array.isArray(missions) &&
			missions.findIndex((inf) => inf.id === missionId) !== -1
		);
	};

	const changePage = (page, pageSize) => {
		setCurrentPage(page);
		setPageSize(pageSize);
	};

	return (
		<>
			<Title
				title={t("missions.pageTitle")}
				extra={<TabNav routes={routes} classNames="spacer" />}
			/>
			<SearchMissions
				setMissions={setMissions}
				currentPage={currentPage}
				setTotalResults={setTotalResults}
				pageSize={pageSize}
				type={type}
			/>
			<Space
				direction="vertical"
				size={16}
				style={{ minWidth: "100%", maxWidth: "100%", paddingBottom: 16 }}
			>
				{missions === null ? (
					<Row gutter={[16, 16]}>
						{[...Array(20)].map((item, key) => (
							<Col key={key} xs={24} sm={12} md={12} lg={8} xl={6}>
								<MissionCard loading={true} />
							</Col>
						))}
					</Row>
				) : missions.length === 0 ? null : (
					<Row gutter={[16, 16]}>
						{missions.map((mission, key) => (
							<Col key={key} xs={24} sm={12} md={12} lg={8} xl={6}>
								{mission.newActivity ? (
									<Badge className="missions-badge" dot>
										<MissionCard
											mission={mission}
											onClick={() => navigate(`${navigationType}${mission.id}`)}
										/>
									</Badge>
								) : (
									<MissionCard
										mission={mission}
										onClick={() => navigate(`${navigationType}${mission.id}`)}
									/>
								)}
							</Col>
						))}
					</Row>
				)}
				<Space>
					<Pagination
						total={totalResults}
						onChange={changePage}
						current={currentPage}
						pageSize={pageSize}
						showSizeChanger
					/>
					<Tag className="total-influencers">
						<Space>
							<Text strong>{returnStatValue(totalResults)}</Text>
							<Text>Missions</Text>
						</Space>
					</Tag>
				</Space>
			</Space>
			<Drawer
				placement="right"
				width=""
				closable={false}
				open={matchMission()}
				className="influencer-details mobile-drawer"
			>
				<MissionAdmin missionId={location.pathname.split("/").slice(-1)[0]} />
			</Drawer>
		</>
	);
};

export default MissionsAdmin;
